const ROUTES_ENUM = {
  alerts: { id: 'alerts', pathname: '/alerts', title: 'Alerts' },
  resources: { id: 'resources', pathname: '/resources', title: 'Resources'},
  departmentInfo: { id: 'department-info', pathname: '/department-info', title: 'department-info' }
}

export default ROUTES_ENUM;